import { WarnBannerController } from './warn-banner.controller';

export const WarnBannerComponent: ng.IComponentOptions = {
  bindings: {
    text: '<',
  },
  templateUrl: 'components/Banners/warn-banner/warn-banner.html',
  controller: WarnBannerController,
};
